















import { defineComponent } from '@vue/composition-api';
import { FOCUSABLE_ERROR_INPUT_CLASS } from '@front-app/components/form/form';
import { autoresize } from '@front-app/directives/autoresize';

export default defineComponent({
	directives: {
		autoresize,
	},
	props: {
		hasError: Boolean,
	},
	setup() {
		return {
			FOCUSABLE_ERROR_INPUT_CLASS,
		};
	},
});
